// RegistrarEmpresa.js
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useBusinessAuth } from '../../Middleware/context/BusinessContext'

export default function RegistrarEmpresa() {
  const navigate = useNavigate()
  const {register } =useBusinessAuth();
  const [loading, setLoading] = useState(false)
  const [dadosEmpresa, setDadosEmpresa] = useState({
    nome: '',
    nif: '',
    email: '',
    whatsapp: '',
    nomegerente: '',
    pais: '',
    localidade: '',
    tipoNegocio: '',
    pagamento: '',
    acordo: false,
    password: '',
    confirmPassword: '',
    parceiro:'Micro-Empresa',
    IBAN:"",
    status:"Pending",
  })

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target
    setDadosEmpresa((prev) => ({
      ...prev,
      [name]: type === 'checkbox' || type === 'radio' ? checked : value,
    }))
  }

  const handlePagamento = (value) => {
    setDadosEmpresa((prev) => ({ ...prev, pagamento: value }))
  }



const handleSubmit = async (e) => {
  e.preventDefault()

  if (!dadosEmpresa.pagamento) {
    alert('Selecione uma opção de pagamento')
    return
  }

  if (dadosEmpresa.password !== dadosEmpresa.confirmPassword) {
    alert('As senhas não coincidem!')
    return
  }

  if (!dadosEmpresa.acordo) {
    alert('É necessário aceitar os termos de acordo')
    return
  }

  try {
    setLoading(true)
    await register(dadosEmpresa)

    alert(
      'Conta criada com sucesso! Verifique o seu e-mail antes de entrar.'
    )

    navigate('/Business/Login') // melhor fluxo
  } catch (error) {
    console.error('Erro ao registar empresa:', error)
    alert(error.message)
  } finally {
    setLoading(false)
  }
}


  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-blue-50 via-blue-100 to-blue-200">
      <form
        onSubmit={handleSubmit}
        className="bg-white shadow-xl rounded-xl p-8 w-full max-w-3xl space-y-10"
      >
        <h2 className="text-2xl font-bold text-blue-700 text-center">
          Registo da Empresa
        </h2>

        {/* Empresa */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <input
            name="nome"
            value={dadosEmpresa.nome}
            onChange={handleChange}
            placeholder="Nome da Empresa"
            required
            className="w-full px-4 py-2 border rounded-lg shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
          />

          <select
            name="tipoNegocio"
            value={dadosEmpresa.tipoNegocio}
            onChange={handleChange}
            className="w-full px-4 py-2 border rounded-lg shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
            required
          >
            <option value="">Selecione o Tipo de Negócio</option>
            <option value="e-commerce">E-commerce</option>
            <option value="service-provider">Service Provider</option>
            <option value="rent-imovel">Rent Imóvel</option>
            <option value="transport"> Delivery</option>
          </select>

          <input
            name="email"
            type="email"
            value={dadosEmpresa.email}
            onChange={handleChange}
            placeholder="Email"
            required
            className="w-full px-4 py-2 border rounded-lg shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
          />

          <input
            name="whatsapp"
            type='telephone'
            value={dadosEmpresa.whatsapp}
            onChange={handleChange}
            placeholder="WhatsApp"
            className="w-full px-4 py-2 border rounded-lg shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
          />

          <input
            name="nif"
            value={dadosEmpresa.nif}
            onChange={handleChange}
            placeholder="NIF"
            required
            className="w-full px-4 py-2 border rounded-lg shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
          />

          <select
            name="pais"
            value={dadosEmpresa.pais}
            onChange={handleChange}
            className="w-full px-4 py-2 border rounded-lg shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
            required
          >
            <option value="">Selecione o País</option>
            <option value="Angola">Angola</option>
            <option value="Namibia">Namíbia</option>
            <option value="RDC">República Democrática do Congo</option>
            <option value="China">China</option>
          </select>
        </div>

        {/* Gerente */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <input
            name="nomegerente"
            value={dadosEmpresa.nomegerente}
            onChange={handleChange}
            placeholder="Nome do Gerente"
            className="w-full px-4 py-2 border rounded-lg shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
          />
          <input
            name="localidade"
            value={dadosEmpresa.localidade}
            onChange={handleChange}
            placeholder="localidade"
            className="w-full px-4 py-2 border rounded-lg shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
          />
        </div>

        {/* Password */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <input
            name="password"
            type="password"
            value={dadosEmpresa.password}
            onChange={handleChange}
            placeholder="Password"
            required
            className="w-full px-4 py-2 border rounded-lg shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
          />
          <input
            name="confirmPassword"
            type="password"
            value={dadosEmpresa.confirmPassword}
            onChange={handleChange}
            placeholder="Confirmar Password"
            required
            className="w-full px-4 py-2 border rounded-lg shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
          />
        </div>

        {/* Pagamento */}
        <fieldset className="space-y-3">
          <legend className="font-semibold text-blue-700">
            Opção de Pagamento
          </legend>
          <label className="flex items-center gap-2">
            <input
              type="radio"
              name="pagamento"
              checked={dadosEmpresa.pagamento === '10+produto'}
              onChange={() => handlePagamento('10+produto')}
              className="accent-blue-600"
            />
            10% no Produto
          </label>
          <label className="flex items-center gap-2">
            <input
              type="radio"
              name="pagamento"
              checked={dadosEmpresa.pagamento === '10-venda'}
              onChange={() => handlePagamento('10-venda')}
              className="accent-blue-600"
            />
            10% na Venda
          </label>
          <label className="flex items-center gap-2">
            <input
              type="radio"
              name="pagamento"
              checked={dadosEmpresa.pagamento === 'silver'}
              onChange={() => handlePagamento('silver')}
              className="accent-blue-600"
            />
            Silver Partner (5000kz/mês)
          </label>
                <label className="flex items-center gap-2">
            <input
              type="radio"
              name="pagamento"
              checked={dadosEmpresa.pagamento === 'Gratis_ate_20_vendas'}
              onChange={() => handlePagamento('Gratis_ate_20_vendas')}
              className="accent-blue-600"
            />
            Iniciando Comercio (Gratis)
          </label>
        </fieldset>

        {/* Acordo */}
        <label className="flex items-center gap-2 text-gray-700">
          <input
            type="checkbox"
            name="acordo"
            checked={dadosEmpresa.acordo}
            onChange={handleChange}
            required
            className="accent-blue-600"
          />
          Aceito os termos de acordo (Que Toda informação Fornecida é verdadeira)
        </label>

        {/* Ações */}
        <div className="flex gap-4 justify-end">
          <button
            type="button"
            onClick={() => navigate('/')}
            className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
          >
            Cancelar
          </button>
       <button
  type="submit"
  disabled={loading}
  className={`px-5 py-2 rounded-lg text-white font-semibold shadow-md transition ${
    loading
      ? 'bg-gray-400 cursor-not-allowed'
      : 'bg-blue-600 hover:bg-blue-700'
  }`}
>
  {loading ? 'A guardar...' : 'Guardar'}
</button>

        </div>
      </form>
    </div>
  )
}